module.exports = __webpack_public_path__ + "static/media/happy7.7197aa04.svg";